import React, { useEffect, useState } from "react";
import TableTree, { Headers, Header, Rows, Row, Cell } from "@atlaskit/table-tree";
import { renderTree } from "../../common/utils/integration.util";
import { useDispatch, useSelector } from "react-redux";
import lodash from "lodash";
import { transparent, Selected } from "../../common/style";
import { selectCred } from "../../redux/actions/credActions";
import { CredentialsType } from "../../common/interfaces/credentials/Credentials";
import key from "../../icons/key.png";
import shield from "../../icons/shield.png";
import password from "../../icons/password.png";
import jwt from "../../icons/jwt.png";
import fingerprint from "../../icons/fingerprint.png";

const AuthTree = () => {
  const [tree, setTree] = useState([]);
  const [isHover, setHover] = useState(null);
  const creds = useSelector((state) => state.auth.creds);
  const selectedCred = useSelector((state) => state.auth.selectedCred);

  const dispatch = useDispatch();

  useEffect(() => {
    if (creds) {
      const newTree = renderTree(creds);
      if (!lodash.isEqual(tree, newTree)) setTree(newTree);
    }
  }, [creds]);
  const onClick = (id) => {
    dispatch(selectCred(id));
  };
  const onMouseover = (id) => {
    setHover(id);
  };
  const onMouseout = (id) => {
    setHover(null);
  };

  const linkStyle = (id) => {
    if (isHover === id) {
      return { cursor: "pointer", fontWeight: "bold" };
    } else {
      return transparent;
    }
  };

  return (
    <div className="credentials-tree-wrapper">
      <h4>Available credentials</h4>
      <TableTree>
        <Headers>
          <Header width="100px">Type</Header>
          <Header width="200px">Name</Header>
        </Headers>
        <Rows
          items={tree}
          render={({ id, name, type, children, hasChildren }) => (
            <Row itemId={id} items={children} hasChildren={hasChildren}>
              <Cell>
                {type === CredentialsType.BASIC_AUTH && <img src={password} width="18" height="18" />}
                {type === CredentialsType.OAUTH2 && <img src={shield} width="18" height="18" />}
                {type === CredentialsType.TOKEN && <img src={key} width="18" height="18" />}
                {type === CredentialsType.JWT && <img src={jwt} width="18" height="18" />}
                {type === CredentialsType.CUSTOM_HEADER && <img src={fingerprint} width="18" height="18" />}
                {type === CredentialsType.AWS_SIGNATURE && <img src={key} width="18" height="18" />}
              </Cell>
              <Cell singleLine onClick={() => onClick(id)} onMouseEnter={() => onMouseover(id)} onMouseLeave={() => onMouseout(id)}>
                {selectedCred.id === id ? <Selected>{name}</Selected> : <div style={linkStyle(id)}>{name}</div>}
              </Cell>
            </Row>
          )}
        />
      </TableTree>
      Count: {creds.length}
    </div>
  );
};

export default AuthTree;
